import { useContext } from "react";
import { MobileNavContext } from "../contexts/MobileNavContext";

const useMobileNav = () => useContext(MobileNavContext);

export default useMobileNav;